export default __webpack_public_path__ + "img/send-email.90b8d83e.svg";